import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from "@angular/common";
import { environment } from "@environment";

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  getApiUrl(): string {
    return isPlatformBrowser(this.platformId) ? environment.apiUrl : environment.internalServicesAddress;
  }
}
